import { render, staticRenderFns } from "./depth.vue?vue&type=template&id=b2ab5d0e&scoped=true&"
import script from "./depth.vue?vue&type=script&lang=js&"
export * from "./depth.vue?vue&type=script&lang=js&"
import style0 from "./depth.vue?vue&type=style&index=0&id=b2ab5d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ab5d0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ab5d0e')) {
      api.createRecord('b2ab5d0e', component.options)
    } else {
      api.reload('b2ab5d0e', component.options)
    }
    module.hot.accept("./depth.vue?vue&type=template&id=b2ab5d0e&scoped=true&", function () {
      api.rerender('b2ab5d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/depth/depth.vue"
export default component.exports